import { Check as CheckIcon, Error as ErrorIcon } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import type React from "react";
import styles from "./index.module.scss";

type ConnectionStatusType = "connecting" | "connected" | "error";

export interface ConnectionStatusProps {
  status: ConnectionStatusType;
  errorMessage?: string;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ status, errorMessage }) => {
  return (
    <div className={styles["connectionStatus"]}>
      <div className={styles["statusContent"]}>
        {status === "connecting" && (
          <>
            <div className={styles["iconWrapper"]}>
              <CircularProgress size={64} sx={{ color: "#1D9FD6" }} />
            </div>
            <p className={styles["statusText"]}>kintoneに接続中</p>
          </>
        )}

        {status === "connected" && (
          <>
            <div className={`${styles["iconWrapper"]} ${styles["success"]}`}>
              <CheckIcon sx={{ fontSize: 48, color: "#FFFFFF" }} />
            </div>
            <p className={styles["statusText"]}>kintoneに接続完了</p>
          </>
        )}

        {status === "error" && (
          <>
            <div className={`${styles["iconWrapper"]} ${styles["error"]}`}>
              <ErrorIcon sx={{ fontSize: 48, color: "#FFFFFF" }} />
            </div>
            <p className={styles["statusText"]}>接続に失敗しました</p>
            {errorMessage && <p className={styles["errorMessage"]}>{errorMessage}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;
